import React from 'react';
import { Link } from 'react-router-dom';

const ImageWithText = ({ settings }) => {
    const {
        title = "Image with text",
        text = "Pair text with an image to focus on your chosen product, collection, or blog post. Add details on availability, style, or even provide a review.",
        image,
        imagePosition = "left",
        ctaText = "Shop now",
        ctaLink = "/shop",
        // Styling
        bg,
        titleColor,
        textColor,
        buttonBg,
        buttonTextColor
    } = settings;

    return (
        <div
            className="w-full py-16 px-8 md:px-4 transition-all duration-300"
            style={{
                backgroundColor: bg || 'var(--store-bg)',
                color: textColor || 'var(--store-text)'
            }}
        >
            <div className={`max-w-7xl mx-auto flex flex-row md:flex-col items-center gap-12 ${imagePosition === 'right' ? 'flex-row-reverse' : ''}`}>
                {/* Image Container */}
                <div className="w-1/2 md:w-full">
                    <div
                        className="relative aspect-[4/3] w-full overflow-hidden rounded-lg transition-colors duration-300"
                        style={{ backgroundColor: bg === 'transparent' ? 'var(--store-card-bg)' : 'rgba(0,0,0,0.05)' }}
                    >
                        {image ? (
                            <img
                                src={image}
                                alt={title}
                                className="h-full w-full object-cover object-center transition-transform duration-500 hover:scale-105"
                            />
                        ) : (
                            <div className="flex h-full w-full items-center justify-center text-[var(--store-muted)]">
                                <span className="text-lg">No image selected</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Text Container */}
                <div className="w-1/2 md:w-full text-left md:text-center">
                    <h2
                        className="text-3xl font-bold tracking-tight sm:text-3xl md:text-4xl mb-6 transition-colors duration-300"
                        style={{ color: titleColor || textColor || 'var(--store-text)' }}
                    >
                        {title}
                    </h2>
                    <p
                        className="text-lg mb-8 leading-relaxed opacity-90 transition-colors duration-300"
                        style={{ color: textColor || 'var(--store-text)' }}
                    >
                        {text}
                    </p>
                    {ctaText && (
                        <Link
                            to={ctaLink}
                            className="inline-block rounded-full px-8 py-3 text-base font-medium transition-all duration-300 hover:opacity-90"
                            style={{
                                backgroundColor: buttonBg || 'var(--store-button-bg)',
                                color: buttonTextColor || 'var(--store-button-text)'
                            }}
                        >
                            {ctaText}
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ImageWithText;
